//bao migrate skip
import templateDialog from "./column-layout-dialog.html";
import * as ko from "knockout";
import * as $ from "jquery";
import baoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import UserProfileLoader from "./../../services/user-profile-service";
import * as translation_DE from "./i18n/de.json";
import * as translation_EN from "./i18n/en.json";
import * as translation_FR from "./i18n/fr.json";

export interface ColumnLayoutComponentParams {
    /**
    * optional: HTMLElement or css selector
    **/
    table?: string | HTMLElement | KnockoutObservable<string> | KnockoutObservable<HTMLElement>;
    /**
    * optional: an id which is used to store and load the config for that layout control
    **/
    id?: string | KnockoutObservable<string> | KnockoutComputed<string>;
    /**
    * optional: is called when component was loaded and initialized
    **/
    loaded?: (columnLayout?: ColumnLayoutComponent) => void;
    /**
    * optional: show layout select - default is false
    **/
    layoutVisible?: boolean | KnockoutObservable<boolean> | KnockoutComputed<boolean>;
}
export class Column {
    Id: string = "";
    Element: HTMLElement = null;
    Caption: KnockoutObservable<string> = ko.observable("");
    OriginalIndex: number = -1;
    Visible = ko.observable(true);
    Parent: ColumnLayoutComponent = null;
    VisibleChanged(newValue: boolean) {
        if (this.Element != null) {
            //toggles the visibility of the ths
            if (newValue) {
                $(this.Element).removeClass("col-layout-hidden");
            }
            else {
                $(this.Element).addClass("col-layout-hidden");
            }
        }
        if (this.Parent != null) {
            //toggles the visibility of the tds
            this.Parent.SetTdVisibility(this.OriginalIndex, newValue);
            this.Parent.SetLastVisibleClass();
        }
    }
    SetColumnCaption() {
        if ($(this.Element).is("[data-column-caption]")) {
            this.Caption($(this.Element).attr("data-column-caption"));
        }
        else {
            this.Caption($(this.Element).text());
        }
    }
    WidthChanged(newValue: string) {
        if (this.Element != null) {
            if (newValue == null || newValue == "") {
                $(this.Element).css("width", "auto");
            }
            else {
                $(this.Element).css("width", newValue);
            }
        }
        if (this.Parent != null) {
            //toggles the visibility of the tds
            this.Parent.SetTdWidth(this.OriginalIndex, newValue);
        }
    }
    Width = ko.observable("");
}
export interface ColumnLayout {
    Name: KnockoutObservable<string>;
    IsSelected: KnockoutObservable<boolean>;
    SelectedColumns: KnockoutObservableArray<string>;
    ColumnsWidth?: Object;
    Id: KnockoutObservable<string>;
}
export class ColumnLayoutComponent {
    private _subs: KnockoutSubscription[] = [];
    private _subsCols: KnockoutSubscription[] = [];
    private _userProfileLoader = UserProfileLoader;
    private _parentElement: HTMLElement;
    constructor(params: ColumnLayoutComponentParams, componentElement: HTMLElement) {
        if (params != null) {
            if (params.layoutVisible != null) {
                if (ko.isObservable(params.layoutVisible)) {
                    this.LayoutSelectVisible = params.layoutVisible;
                }
                else {
                    this.LayoutSelectVisible(ko.unwrap(params.layoutVisible));
                }
            }
            if (params.id != null) {
                this.Id = <any>ko.unwrap(params.id);
                if (ko.isObservable(params.id) || ko.isComputed(params.id)) {
                    this._subs.push((<KnockoutObservable<string>>(params.id)).subscribe((newId) => {
                        //reinit logic
                        this.Id = newId;
                        this.Initialized(false);
                        this.InitControl(params != null ? params : {}, componentElement);
                        this.Load();
                    }));
                }
            }
        }
        this._subs.push(this.SelectedLayoutId.subscribe((newId) => {
            this.LoadLayout(this.GetLayout(newId));
        }));
        this._subs.push(this.LayoutSelectVisible.subscribe((newValue) => {
            this.UpdateLayoutMode();
        }));
        this.InitControl(params != null ? params : {}, componentElement);
        setTimeout(() => {
            if (params != null) {
                if (params.loaded != null) {
                    params.loaded(this);
                }
            }
            this.Load();
        }, 0);
    }
    Id: string = "-1";
    LayoutItems = ko.observableArray<ColumnLayout>([]);
    SelectedLayoutId = ko.observable<string>(null);
    SelectedLayout = ko.observable<ColumnLayout>(null);
    Initialized = ko.observable(false);
    Columns: Column[] = null;
    TableElement: HTMLElement = null;
    LayoutSelectVisible = ko.observable(false);
    InitControl(params: ColumnLayoutComponentParams, componentElement: HTMLElement) {
        let $table: JQuery;
        if (params != null) {
            let t: string | HTMLElement = ko.unwrap(<any>(params.table));
            if (t != null) {
                let $table = $(t as any);
            }
            else if (componentElement != null) {
                $table = $(componentElement).siblings("table").first();
                if ($table.length == 0) {
                    $table = $(componentElement).next().find("table").first();
                }
            }
        }
        if ($table != null && $table.length > 0) {
            this._parentElement = $(componentElement).parent().get(0);
            this.TableElement = $table.get(0);
            this.Columns = this.ReadColumns(this.TableElement);
            this.LayoutItems([]);
            this.LayoutItems.push(this.CreateDefaultLayout());
            this.SelectedLayoutId(this.LayoutItems()[0].Id());
            this.InitMutoTd();
            this.SetLastVisibleClass();
            this.SetTableHorizontalScroll();
            this.UpdateLayoutMode();
        }
        this.Translate();
    }
    private UpdateLayoutMode() {
        if (this.LayoutSelectVisible()) {
            $(this._parentElement).removeClass("bao-column-layout-container");
        }
        else {
            $(this._parentElement).addClass("bao-column-layout-container");
        }
    }
    private SetTableHorizontalScroll() {
        if (this.TableElement) {
            this.TableElement.parentElement.style.overflowX = 'auto';
        }
    }
    private _mutoTds: MutationObserver;
    private InitMutoTd() {
        if (this._mutoTds != null) {
            this._mutoTds.disconnect();
        }
        this._mutoTds = new MutationObserver(() => {
            this.SyncVisibility();
        });
        this._mutoTds.observe($("tbody", this.TableElement).get(0), {
            childList: true,
            subtree: false,
            attributes: false
        });
    }
    SyncVisibility() {
        if (this.TableElement != null && this.Columns != null) {
            let helper = this.DetachHelper(this.TableElement);
            $("th", this.TableElement).each((index) => {
                this.SetTdIndex(index, this.TableElement);
            });
            ko.utils.arrayForEach(this.Columns, (c) => {
                this.SetTdVisibility(c.OriginalIndex, c.Visible());
            });
            this.SetLastVisibleClass();
            helper();
        }
    }
    /**
     * Is used to create the default layout after the component (and columns) was initialized
     */
    private CreateDefaultLayout(): ColumnLayout {
        let layout = {
            IsSelected: ko.observable(true),
            Name: this.Captions.DefaultLayout,
            SelectedColumns: ko.observableArray([]),
            Id: ko.observable("1"),
            ColumnsWidth: null
        };
        ko.utils.arrayForEach(this.Columns, (c, index) => {
            if (c.Visible()) {
                layout.SelectedColumns().push(c.Id);
            }
        });
        return layout;
    }
    /**
     * Creates a new layout with an incremented id and adds the layout to the layout list
     */
    CreateLayout(): ColumnLayout {
        let highestId: number = 1;
        ko.utils.arrayForEach(this.LayoutItems(), (existingLayout) => {
            let id: number = parseInt(existingLayout.Id());
            if (isNaN(id) == false) {
                if (highestId < id) {
                    highestId = id;
                }
            }
        });
        let layout: ColumnLayout = {
            Id: ko.observable("" + (highestId + 1)),
            IsSelected: ko.observable(false),
            Name: ko.observable("Layout " + (highestId + 1)),
            SelectedColumns: ko.observableArray([]),
            ColumnsWidth: null
        };
        ko.utils.arrayForEach(this.Columns, (c) => {
            layout.SelectedColumns().push(c.Id);
        });
        this.LayoutItems.push(layout);
        this.SelectedLayoutId(layout.Id());
        return layout;
    }
    RemoveLayout() {
        if (this.SelectedLayout() != null) {
            this.LayoutItems.remove(this.SelectedLayout());
            this.SelectedLayoutId(this.LayoutItems()[0].Id());
        }
    }
    /**
     * This method reads all columns from the assigned table element
     * @param table
     */
    ReadColumns(table: HTMLElement): Column[] {
        let result: Column[] = [];
        ko.utils.arrayForEach(this._subsCols, (s) => {
            s.dispose();
        });
        this._subsCols = [];
        $("th", table).each((index, elem: HTMLElement) => {
            if ($(elem).is("[data-column-ignore]") == false) {
                let c = new Column();
                c.Element = elem;
                c.Id = "col-" + index;
                c.OriginalIndex = index;
                c.Parent = this;
                c.Visible($(elem).css("display") != "none");
                if ($(elem).is("[data-column-id]")) {
                    c.Id = $(elem).attr("data-column-id");
                }
                c.SetColumnCaption();
                this.SetTdIndex(index, table);
                this._subsCols.push(c.Visible.subscribe((newValue) => {
                    c.VisibleChanged(newValue);
                }));
                this._subsCols.push(c.Width.subscribe((newWidth) => {
                    if (this.layoutChangeInProgress == false && this.SelectedLayout() != null && this.SelectedLayout().Id() != "1") {
                        if (this.SelectedLayout().ColumnsWidth == null) {
                            this.SelectedLayout().ColumnsWidth = {};
                        }
                        this.SelectedLayout().ColumnsWidth[c.Id] = ko.unwrap(newWidth);
                        c.WidthChanged(newWidth);
                    }
                }));
                result.push(c);
            }
        });
        return result;
    }
    private DetachHelper(ele: HTMLElement): () => void {
        var parentNode = ele.parentNode;
        var nextSibling = ele.nextSibling;
        if (parentNode != null) {
            parentNode.removeChild(ele);
        }
        return function () {
            if (parentNode != null) {
                if (nextSibling) {
                    parentNode.insertBefore(ele, nextSibling);
                }
                else {
                    parentNode.appendChild(ele);
                }
            }
        };
    }
    SetLastVisibleClass() {
        let helper = this.DetachHelper(this.TableElement);
        $(".col-layout-last", this.TableElement).removeClass("col-layout-last");
        let lastVisibleCol: Column = null;
        ko.utils.arrayForEach(this.Columns, (c) => {
            if (c.Visible()) {
                lastVisibleCol = c;
            }
        });
        if (lastVisibleCol != null) {
            $(lastVisibleCol.Element).addClass("col-layout-last");
            let selector = "td[data-col-index=" + lastVisibleCol.OriginalIndex + "]";
            $(selector, this.TableElement).addClass("col-layout-last");
        }
        helper();
    }
    private SetTdIndex(index: number, table: HTMLElement) {
        let tdSelector = "td:nth-of-type(" + (index + 1) + ")";
        $(tdSelector, table).attr("data-col-index", index);
    }
    SetTdVisibility(index: number, visible: boolean) {
        let selector = "td[data-col-index=" + index + "]";
        if (visible) {
            $(selector, this.TableElement).removeClass("col-layout-hidden");
        }
        else {
            $(selector, this.TableElement).addClass("col-layout-hidden");
        }
    }
    SetTdWidth(index: number, width: string) {
        let selector = "td[data-col-index=" + index + "]";
        if (width == null || width == "") {
            $(selector, this.TableElement).css("width", "auto");
        }
        else {
            $(selector, this.TableElement).css("width", width);
        }
    }
    /**
     * Is used to serialize the LayoutList, e.g. to save them on the server
     */
    Serialize(): string {
        return JSON.stringify(ko.map.toJS(this.LayoutItems()));
    }
    /**
     *
     * @param s : json string which represent the Layout Array for this
     */
    Deserialize(s: string): void {
        let layouts: ColumnLayout[] = ko.unwrap(ko.map.fromJSON(s));
        if (layouts.length == 0) {
            layouts.push(this.CreateDefaultLayout());
        }
        let selectedLayout = null;
        let filteredLayout: ColumnLayout[] = [];
        ko.utils.arrayForEach(layouts, (l) => {
            if (ko.utils.arrayFirst(filteredLayout, (item) => { return item.Id() == l.Id(); }) == null) {
                if (selectedLayout == null && l.IsSelected()) {
                    selectedLayout = l;
                }
                else {
                    l.IsSelected(false);
                }
                if (l.Id() == "1") {
                    l = this.CreateDefaultLayout(); //Default Layout should not be changed!
                }
                l.ColumnsWidth = ko.map.toJS(l.ColumnsWidth);
                filteredLayout.push(l);
            }
        });
        this.LayoutItems(filteredLayout);
        if (selectedLayout != null) {
            this.LoadLayout(selectedLayout);
        }
    }
    /**
     * Method to save the current settings on server (usersettings)
     */
    Save(): JQueryPromise<any> {
        if (this.Initialized() && this.Id != null && this.Id != "") {
            return this._userProfileLoader.Save("column_layout_" + this.Id, this.Serialize());
        }
    }
    /**
    * Method to load the current settings from server (usersettings)
    */
    Load() {
        if (this.Columns != null && this.Id != null && this.Id != "") {
            return this._userProfileLoader.Load("column_layout_" + this.Id).then((result) => {
                if (Bao.Utils.String.IsNullOrEmpty(result) == false) {
                    this.Deserialize(result);
                }
                this.Initialized(true);
            });
        }
    }
    private layoutChangeInProgress = false;
    /**
     * Applies the settings of the layout
     * @param layout
     */
    LoadLayout(layout: ColumnLayout): void {
        if (layout != null && this.Columns != null) {
            this.layoutChangeInProgress = true;
            ko.utils.arrayForEach(this.Columns, (c) => {
                let foundColumns = ko.utils.arrayFilter(layout.SelectedColumns(), (layoutCol) => {
                    return layoutCol == c.Id;
                });
                let colVisible = foundColumns != null && foundColumns.length > 0;
                c.Visible(colVisible);
                let colWidth = "";
                if (layout.ColumnsWidth != null && layout.ColumnsWidth[c.Id] != null) {
                    colWidth = ko.unwrap(layout.ColumnsWidth[c.Id]);
                }
                c.Width(colWidth);
                c.WidthChanged(colWidth);
            });
            this.SelectedLayoutId(layout.Id());
            this.SelectedLayout(layout);
            ko.utils.arrayForEach(this.LayoutItems(), (l) => {
                l.IsSelected(false);
            });
            layout.IsSelected(true);
            this.layoutChangeInProgress = false;
        }
    }
    /**
     *  Searches in the LayoutItems for the specified id
     * @param layoutId
     */
    GetLayout(layoutId: string): ColumnLayout {
        let foundLayout = ko.utils.arrayFirst(this.LayoutItems(), (l) => {
            return l.Id() == layoutId;
        });
        return foundLayout;
    }
    private _Dialog: baoDialog;
    /**
     * Is called from gui to open the setup dialog
     */
    SetupLayout() {
        //read the captions again - properly they changed due to observables / bao messages
        if (this.Columns != null) {
            ko.utils.arrayForEach(this.Columns, (c) => {
                c.SetColumnCaption();
            });
        }
        if (this._Dialog == null) {
            this._Dialog = new baoDialog(Bao.Session.ApplicationName);
            this._Dialog.Width("500px");
            this._Dialog.Buttons([new baoDialog.ButtonFactory(this._Dialog, Bao.Session.GetMessage("msgOk"), () => {
                    this._Dialog.Close();
                })]);
            this._Dialog.Closed = () => {
                this.Save();
            };
            this._Dialog.Template(templateDialog);
            this._Dialog.ViewModel(this);
        }
        this._Dialog.Open();
    }
    /**
     * Is used to toggle the visibility of a column
     * @param col
     */
    ToggleColumn(col: Column) {
        if (col != null) {
            col.Visible(!col.Visible());
        }
        //synchronize the layout columns!
        let visibleCols: string[] = [];
        ko.utils.arrayForEach(this.Columns, (c) => {
            if (c.Visible()) {
                visibleCols.push(c.Id);
            }
        });
        if (this.SelectedLayout() != null) {
            this.SelectedLayout().SelectedColumns(visibleCols);
        }
    }
    /**
     * Is used to toggle the visibility of a column
     * @param col
     */
    GetColumn(colId: string) {
        if (this.Columns != null) {
            let c = ko.utils.arrayFirst(this.Columns, (col) => {
                return col.Id == colId;
            });
            return c;
        }
        return null;
    }
    Translate() {
        let lang = "de";
        if (Bao != null && Bao.Session != null && Bao.Session.Language != null && Bao.Session.Language.Symbol != null && !Bao.Utils.String.IsNullOrEmpty(Bao.Session.Language.Symbol())) {
            lang = Bao.Session.Language.Symbol().substring(0,2);
        }
        switch(lang) {
            case "de":
                ko.map.fromJS(translation_DE as any, this.Captions);
                break;
            case "fr":
                ko.map.fromJS(translation_FR as any, this.Captions);
                break;
            default:
                ko.map.fromJS(translation_EN as any, this.Captions);
                break;
        }
        // window.baorequire(["text!./i18n/" + lang + ".json"], (result) => {
        //     let parsed = JSON.parse(result);
        //     ko.map.fromJS(parsed, this.Captions);
        // });
    }
    Captions = {
        Name: ko.observable("Name"),
        Layout: ko.observable("Layout"),
        DefaultLayout: ko.observable("Standardlayout"),
        TooltipButton: ko.observable("Layout"),
        PlaceholderWidth: ko.observable("width")
    };
    /**
     * Is called by knockout when component is destroyed to cleanup things
     */
    dispose() {
        ko.utils.arrayForEach(this._subs, (s) => {
            s.dispose();
        });
        ko.utils.arrayForEach(this._subsCols, (s) => {
            s.dispose();
        });
        if (this._Dialog != null) {
            this._Dialog.Close();
            this._Dialog.Destroy();
        }
        if (this._mutoTds != null) {
            this._mutoTds.disconnect();
        }
    }
}